module.exports = __webpack_public_path__ + "img/login-background.54a91d2d.jpg";